module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-modal"
  }, [_c('mt-popup', {
    staticClass: "guestInfo-delay",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.bshow),
      callback: function($$v) {
        _vm.bshow = $$v
      },
      expression: "bshow"
    }
  }, [_c('div', {
    staticClass: "delayIn-main"
  }, [_c('div', {
    ref: "poster",
    staticClass: "main"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('scanPay_title')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('hotelName')) + "：" + _vm._s(_vm.hotelName))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fangTXQ_bookName')) + "：" + _vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fangTXQ_bookTime')) + "：" + _vm._s(_vm.arr))])]), _vm._v(" "), _c('div', {
    ref: "qrCodeDiv",
    staticClass: "qrCode",
    attrs: {
      "id": "qrCode"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.qrCodeSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fangTXQ_transactionAmount')) + "：" + _vm._s(_vm.price))])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        return _vm.onExport('download')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_savePictrue')) + "\n        ")]), _vm._v(" "), (!_vm.isIos) ? _c('div', {
    staticClass: "sure",
    on: {
      "click": function($event) {
        return _vm.onExport('share')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_forwardWechat')) + "\n        ")]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-332f21c4","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/qrcodeModal.vue
// module id = 1763
// module chunks = 107